<template>
  <div class="labeled-control-full-width">
    <p :class="{ wm_label_disabled: disabled }">{{ label }}</p>
    <textarea
      class="wm_textarea wm_input"
      :type="type"
      rows="4"
      v-model="displayValue"
      :placeholder="placeholder"
      :disabled="disabled"
      :class="{ wm_input_disabled: disabled }"
      autocomplete="off"
      @focus="isEditing = true"
      @blur="isEditing = false"
    ></textarea>
  </div>
</template>

<script>
import { _ } from "vue-underscore";
export default {
  name: "LabeledTextAreaReports",
  props: {
    label: { type: String },
    placeholder: { type: String, default: "" },
    modelValue: {},
    type: { type: String },
    disabled: { type: Boolean },
    // New props for templating:
    sidebarOpen: { type: Boolean, default: true },
    templateData: { type: Object, default: () => ({}) }
  },
  emits: ['update:modelValue'],
  data() {
    return {
      isEditing: false
    };
  },
  computed: {
    displayValue: {
      get() {
        // When editing or if the sidebar is open, show the raw value.
        if (this.isEditing || this.sidebarOpen) {
          return this.modelValue;
        } else {
          // Otherwise, process the raw value through your templating logic.
          return this.processValue(this.modelValue, this.templateData);
        }
      },
      set(newValue) {
        this.$emit('update:modelValue', newValue);
      }
    }
  },
  methods: {
    formatDate(dateString) {
      const d = new Date(dateString);
      const year = d.getFullYear();
      // getMonth() returns 0-indexed month so add 1 and pad with 0 if needed
      const month = ('0' + (d.getMonth() + 1)).slice(-2);
      const day = ('0' + d.getDate()).slice(-2);
      return `${year}-${month}-${day}`;
    },
    // formatDate(isoTimestamp) {
    //   const date = new Date(isoTimestamp); // Parse the ISO timestamp
    //   date.setUTCDate(date.getUTCDate()); // Add one day since when selecting date it is set to 23:00 the day before. So need to round up.
    //   const year = date.getUTCFullYear(); // Get the year
    //   const month = String(date.getUTCMonth() + 1).padStart(2, "0"); // Get the month (add 1 because getUTCMonth is zero-based)
    //   const day = String(date.getUTCDate()).padStart(2, "0"); // Get the day
    //   return `${year}-${month}-${day}`; // Format as YYYY-MM-DD
    // },

    processValue(raw, data) {
      try {
        if (data.diagram) {
          data.diagram.to_date = this.formatDate(data.diagram.to_date)
          data.diagram.to_date_year_month = this.formatDate(data.diagram.to_date).slice(0, 7);
          data.diagram.to_date_year = this.formatDate(data.diagram.to_date).slice(0, 4);
        

          data.diagram.from_date = this.formatDate(data.diagram.from_date)
          data.diagram.from_date_year_month = this.formatDate(data.diagram.from_date).slice(0, 7);
          data.diagram.from_date_year = this.formatDate(data.diagram.from_date).slice(0, 4);
          
        }
        // Use your custom delimiter for interpolation. Adjust the regex as needed.
        const tpl = _.template(raw, { interpolate: /<\(=([\w.]+)\)>/g });
        return tpl(data) || raw;
      } catch (e) {
        return raw;
      }
    }
  }
};
</script>
<style>
textarea.wm_textarea {
  resize: vertical; /* Allows vertical resizing only */
}
</style>
